import { Card, CardContent } from '@/components/ui/card';
import { Package, AlertTriangle, XCircle, TrendingUp } from 'lucide-react';
import type { InventoryStock } from '@/types/database/inventory';

interface InventoryKPICardsProps {
  stock: InventoryStock[] | undefined;
  isLoading: boolean;
}

export function InventoryKPICards({ stock, isLoading }: InventoryKPICardsProps) {
  const totalProducts = stock?.length || 0;
  const totalQuantity = stock?.reduce((sum, item) => sum + item.current_quantity, 0) || 0;
  const lowStockCount = stock?.filter(
    (item) => item.reorder_level > 0 && item.current_quantity > 0 && item.current_quantity <= item.reorder_level
  ).length || 0;
  const outOfStockCount = stock?.filter((item) => item.current_quantity <= 0).length || 0;

  const cards = [
    {
      title: 'Total Products',
      value: totalProducts.toLocaleString(),
      icon: Package,
      iconBg: 'bg-primary/10',
      iconColor: 'text-primary',
    },
    {
      title: 'Total Quantity',
      value: totalQuantity.toLocaleString(),
      icon: TrendingUp,
      iconBg: 'bg-accent/10',
      iconColor: 'text-accent',
    },
    {
      title: 'Low Stock',
      value: lowStockCount.toLocaleString(),
      icon: AlertTriangle,
      iconBg: 'bg-harvest-warning/10',
      iconColor: 'text-harvest-warning',
    },
    {
      title: 'Out of Stock',
      value: outOfStockCount.toLocaleString(),
      icon: XCircle,
      iconBg: 'bg-destructive/10',
      iconColor: 'text-destructive',
    },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {cards.map((card) => (
        <Card key={card.title}>
          <CardContent className="p-4 flex items-center gap-4">
            <div className={`stat-card-icon ${card.iconBg}`}>
              <card.icon className={`h-5 w-5 ${card.iconColor}`} />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">{card.title}</p>
              {isLoading ? (
                <div className="h-7 w-12 rounded bg-muted animate-pulse" />
              ) : (
                <p className="text-2xl font-bold">{card.value}</p>
              )}
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
